import masterBedroomImage from '../images/master_bedroom.jpeg';
import miniBedroomImage from '../images/mini_bedroom.jpeg';
import childrensBedroomImage from '../images/childrens_bedroom.jpeg';
import outsideKitchenImage from '../images/outside_kitchen.jpeg';
import frontviewImage from '../images/frontview.jpg';
import livingRoomImage from '../images/living_room.jpeg';
import diningRoomImage from '../images/dining_room.jpeg';
import playAreaImage from '../images/play_area.jpeg';

const home_page_sections = [
    {
        title: "Master Bedroom",
        description: "Our spacious master bedroom offers a luxurious retreat with a king-size bed, premium bedding, a dresser, ample closet space, and an en-suite bathroom. Perfect for couples or solo travelers seeking comfort and privacy.",
        price: "₦25,000",
        pricePer: "per night",
        image: [{src: masterBedroomImage, alt: 'Master Bedroom'}]
    },
    {
        title: "Mini Bedroom",
        description: "A cozy and affordable option featuring a comfortable single bed, dresser, and closet. Ideal for solo travelers or as a supplementary sleeping space.",
        price: "₦12,000",
        pricePer: "per night",
        image: [{src: miniBedroomImage, alt: 'Mini Bedroom'}]
    },
    {
        title: "Children's Bedroom",
        description: "A charming room designed with families in mind, featuring a single bed, dresser, and closet. Located near the main living areas for peace of mind.",
        price: "₦15,000",
        pricePer: "per night",
        image: [{src: childrensBedroomImage, alt: "Children's Bedroom"}]
    },
    {
        title: "Outside Kitchen",
        description: "A fully-equipped outdoor kitchen space complete with cooking facilities, dining area, and traditional outdoor amenities. Perfect for guests who prefer to prepare their own meals while enjoying the outdoor atmosphere.",
        price: "₦18,000",
        pricePer: "per night",
        image: [{src: outsideKitchenImage, alt: 'Outside Kitchen'}]
    }
]

export default home_page_sections;
